import React, { useState } from 'react'
import './QuestionItem.css'
import { ProgressBar } from 'react-bootstrap';
import { FaCheck, FaClock, FaTimes } from 'react-icons/fa';

function QuestionItem({ welcomeicon, text, progressBar, customTime, isClickedDisabled, onClick, isSelected, isCorrect, isDisabled }) {
    const [isClicked, setIsClicked] = useState(false);

    const handleClick = () => {
        if (!isDisabled) {
            setIsClicked(!isClicked);
            onClick();
        }
    };

    return (
        <div
            className={`custom-question-item ${isSelected ? 'bg-selected' : ''
                } ${isCorrect === 1 ? 'bg-correct' : isCorrect === 0 ? 'bg-incorrect' : 'bg-default'
                }`}
            onClick={handleClick}
        >
            <div className="d-flex">
                {welcomeicon && <img src={welcomeicon} className="welcomeicon me-2" />}
                <div>
                    <p className="mb-0 font-18">{text}</p>
                    {progressBar && (
                        <ProgressBar
                            now={progressBar.now}
                            className="custom-progress-bar new"
                            variant="primary"
                            label={`${progressBar.now}%`}
                        />
                    )}
                </div>
                {isCorrect !== undefined && (
                    <div className="answer-indicator">
                        {isCorrect ? <FaCheck className="text-success mx-2" /> : <FaTimes className="text-danger mx-2" />}
                    </div>
                )}
            </div>
            {/* {customTime && (
                <div className="custom-time">
                    <span>
                        <FaClock />
                    </span>
                    <span>{customTime}</span>
                </div>
            )} */}
        </div>
    );
}

export default QuestionItem;
